import _ from 'lodash'

import { complianceBreachApi } from '@atheneum/api'
import { extendObservable } from 'mobx'

class ComplianceBreachStore {
  constructor () {
    extendObservable(this, {
      complianceBreachList: { rows: [], count: 0 },
      expertResults: [],
      loading: false
    })
  }

  async getAll (filters, order, orderBy, page, employees) {
    this.loading = true

    let expertId
    if (filters.expertId) {
      const res = await complianceBreachApi.autocomplete(filters.expertId)
      expertId = res.filter(r => r.fullName === filters.expertId)[0]?.id
    }

    let userId
    if (filters.userId) {
      const res = await complianceBreachApi.userSearch(filters.userId)
      userId = res.filter(r => r.name === filters.userId)[0]?.id
    }

    if (filters.accManager) {
      let userIds = []

      if (filters.accManager === 'None') {
        const teams = _.uniq(employees.map(e => e.teamId).filter(e => e))

        teams.forEach(team => {
          const staff = employees.filter(e => e.teamId === team)
          const accManager = staff.filter(s => s.positionId === 5 && s.active)

          if (accManager.length === 0) {
            userIds = userIds.concat(staff.map(s => s.value))
          }
        })

        const additionalIds = employees
          .filter(e => e.team === null)
          .map(e => e.value)

        userIds = userIds.concat(additionalIds)
      } else {
        const teamId = employees.filter(e => e.label === filters.accManager)[0]
          ?.teamId

        if (teamId) {
          employees.forEach(e => {
            if (e.teamId === teamId && !userIds.includes(e.value)) {
              userIds.push(e.value)
            }
          })
        }
      }

      userId = userIds
    }

    if (filters.team) {
      delete filters.accManager
      const userIds = employees
        .filter(e => e.team === (filters.team === 'None' ? null : filters.team))
        .map(e => e.value)

      userId = userIds
    }

    return complianceBreachApi
      .getAll(
        {
          ..._.omit(filters, ['team', 'accManager']),
          expertId: expertId ? expertId : undefined,
          userId: userId ? userId : undefined
        },
        order,
        orderBy,
        page
      )
      .then(result => {
        this.complianceBreachList = result
        this.loading = false
      })
      .catch(e => {
        this.loading = false
        console.error(e)
      })
  }

  confirm (id, status) {
    this.loading = true
    return complianceBreachApi
      .confirm(id, status)
      .then(() => {
        this.getAll().then(() => {
          this.loading = false
        })
      })
      .catch(e => {
        this.loading = false
        console.error(e)
      })
  }

  expertSearch (keyword) {
    return complianceBreachApi
      .autocomplete(keyword)
      .then(res => {
        return res.map(r => r.fullName)
      })
      .catch(e => {
        console.error(e)
      })
  }

  userSearch (keyword) {
    return complianceBreachApi
      .userSearch(keyword)
      .then(res => {
        return res.map(r => r.name)
      })
      .catch(e => {
        console.error(e)
      })
  }
}

export default ComplianceBreachStore
